import { useQuery } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import {
  ApiResponse,
  LevelApiResponse,
  RecommendRoles,
  RoleApiResponse,
  RoleCategory,
  Roles,
} from '@/shared/types';

export const useRoleQuery = () => {
  return useQuery({
    queryKey: ['getRoleApi'],
    queryFn: async () => {
      const response =
        await clientAxios.get<ApiResponse<RoleApiResponse>>('/profileRoleApi/');
      const data = response.data.data;

      const categories: RoleCategory[] = [];
      const roles: Roles = {};
      const recommendRoles: RecommendRoles[] = [];
      let constants = {};

      Object.keys(data).forEach((key) => {
        categories.push({ key, kor: data[key].kor });
        roles[key] = data[key].roles;
        constants = { ...constants, ...data[key].roles };
        recommendRoles.push({
          key,
          kor: data[key].kor,
          data: data[key].recommend_roles,
        });
      });

      return {
        categories,
        roles,
        recommendRoles,
        constants,
      };
    },
  });
};

export const useLevelQuery = () => {
  return useQuery({
    queryKey: ['getLevel'],
    queryFn: async () => {
      const response =
        await clientAxios.get<ApiResponse<LevelApiResponse>>(
          '/profileLevelApi/'
        );
      const data = response.data.data;
      const levelData = Object.keys(data).map((key) => ({
        key: key.toLowerCase(),
        value: data[key],
      }));

      return {
        levelData,
        constants: data,
      };
    },
  });
};
